(function (root) {
  "use strict";

  function buildHandednessProperties(pack, values) {
    var size = Number(pack);
    var properties = {};

    for (var index = 0; index < size; index += 1) {
      if (!values[index]) {
        throw new Error("Choose handedness for trainer " + (index + 1));
      }
      properties["_Trainer " + (index + 1) + " Handedness"] = values[index];
    }

    return properties;
  }

  function buildCartItem(variantId, pack, handedness) {
    var id = Number(variantId);
    if (!Number.isFinite(id) || id <= 0) throw new Error("Choose a valid pack");
    return {
      id: id,
      quantity: 1,
      properties: buildHandednessProperties(pack, handedness),
    };
  }

  var api = {
    buildHandednessProperties: buildHandednessProperties,
    buildCartItem: buildCartItem,
  };
  root.WBGGripTrainer = api;

  if (typeof document === "undefined") return;

  function query(rootElement, selector) {
    return rootElement.querySelector(selector);
  }

  function queryAll(rootElement, selector) {
    return Array.prototype.slice.call(rootElement.querySelectorAll(selector));
  }

  function makeHandednessControl(index, value) {
    var label = document.createElement("label");
    label.className = "wbg-hand";
    label.dataset.wbgHandednessItem = String(index + 1);

    var number = document.createElement("span");
    number.textContent = "#" + (index + 1);

    var select = document.createElement("select");
    select.name = "properties[_Trainer " + (index + 1) + " Handedness]";
    select.setAttribute("aria-label", "Trainer " + (index + 1) + " handedness");

    ["Right-Handed", "Left-Handed"].forEach(function (optionValue) {
      var option = document.createElement("option");
      option.value = optionValue;
      option.textContent = optionValue;
      option.selected = optionValue === value;
      select.appendChild(option);
    });

    label.appendChild(number);
    label.appendChild(select);
    return label;
  }

  function enhanceGallery(product) {
    var slides = queryAll(product, "[data-wbg-slide]");
    var thumbs = queryAll(product, "[data-wbg-gallery-index]");
    var current = 0;

    // Inactive slides are display:none, and the browser never fetches a lazy
    // image inside a hidden element. Left alone, every swipe starts a fresh
    // download and the slot sits blank. So pull each one into the HTTP cache
    // ahead of time; the real <img> then paints from cache instantly.
    var idle =
      window.requestIdleCallback ||
      function (cb) {
        return setTimeout(cb, 1);
      };

    function warmSlide(index, priority) {
      var slide = slides[(index + slides.length) % slides.length];
      if (!slide || slide.dataset.wbgWarmed === "true") return null;
      var img = slide.querySelector("img");
      if (!img) return null;
      slide.dataset.wbgWarmed = "true";
      var pre = new Image();
      // Background warming must never outrank the hero still painting.
      if ("fetchPriority" in pre) pre.fetchPriority = priority || "low";
      // sizes must be set before srcset for the right candidate to be chosen.
      if (img.getAttribute("sizes")) pre.sizes = img.getAttribute("sizes");
      if (img.getAttribute("srcset")) pre.srcset = img.getAttribute("srcset");
      pre.src = img.currentSrc || img.src;
      return pre;
    }

    // Warming all 11 costs ~1.3MB on a phone, and most shoppers never reach the
    // end of the gallery. So keep a rolling window ahead of wherever they are:
    // whoever swipes always finds the next image already cached, and nobody pays
    // for images they never look at.
    var LOOKAHEAD = 3;
    function warmAround(index) {
      for (var d = 1; d <= LOOKAHEAD; d += 1) {
        warmSlide(index + d);
        warmSlide(index - d);
      }
    }

    var warmedAll = false;
    function warmAll() {
      if (warmedAll) return;
      warmedAll = true;
      var i = 0;
      (function step() {
        var inFlight = 0;
        while (i < slides.length && inFlight < 2) {
          var pre = warmSlide(i);
          i += 1;
          if (pre) {
            inFlight += 1;
            pre.addEventListener("load", step, { once: true });
            pre.addEventListener("error", step, { once: true });
          }
        }
        if (inFlight === 0 && i < slides.length) idle(step);
      })();
    }



    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.hidden = !active;
        slide.classList.toggle("is-active", active);
      });
      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === current;
        thumb.classList.toggle("is-active", active);
        thumb.setAttribute("aria-selected", active ? "true" : "false");
      });
      // Whichever way they go next, it is already in cache.
      warmAround(current);
    }

    // Neighbours first at normal priority, then the rest the moment the hero has
    // painted. Waiting for window "load" was too late on mobile, where posters
    // and third-party scripts push that event out by seconds.
    warmSlide(1, "high");
    warmSlide(slides.length - 1, "high");

    function startWarming() {
      // Neighbours first so an immediate swipe is covered, then the whole set a
      // beat later at low priority. Deferring it keeps the hero and the buy box
      // uncontended, but by the time anyone swipes twice it is all cached.
      warmAround(0);
      var c = navigator.connection;
      if (c && c.saveData) return;
      setTimeout(function () {
        idle(warmAll);
      }, 1200);
    }

    var hero = slides[0] && slides[0].querySelector("img");
    if (!hero || (hero.complete && hero.naturalWidth > 0)) {
      startWarming();
    } else {
      hero.addEventListener("load", startWarming, { once: true });
      hero.addEventListener("error", startWarming, { once: true });
      // Never let a stalled hero hold the rest of the gallery hostage.
      setTimeout(startWarming, 2500);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        show(Number(thumb.getAttribute("data-wbg-gallery-index")));
      });
    });
    var previous = query(product, "[data-wbg-gallery-previous]");
    var next = query(product, "[data-wbg-gallery-next]");
    if (previous)
      previous.addEventListener("click", function () {
        show(current - 1);
      });
    if (next)
      next.addEventListener("click", function () {
        show(current + 1);
      });

    var stage = query(product, ".wbg-gallery__stage");
    var touchStart = null;
    if (stage) {
      stage.addEventListener(
        "touchstart",
        function (event) {
          touchStart = event.changedTouches[0].clientX;
        },
        { passive: true },
      );
      stage.addEventListener(
        "touchend",
        function (event) {
          if (touchStart === null) return;
          var distance = event.changedTouches[0].clientX - touchStart;
          if (Math.abs(distance) > 45) show(current + (distance < 0 ? 1 : -1));
          touchStart = null;
        },
        { passive: true },
      );
    }
  }

  function enhanceProduct(product) {
    if (product.dataset.wbgEnhanced === "true") return;
    product.dataset.wbgEnhanced = "true";
    enhanceGallery(product);

    var form = query(product, "[data-wbg-form]");
    var packButtons = queryAll(product, "[data-wbg-pack]");
    var handednessList = query(product, "[data-wbg-handedness-list]");
    var handednessFieldset = query(product, "[data-wbg-handedness]");
    var baseOption = query(product, "[data-wbg-base-option]");
    var baseHand = query(product, "[data-wbg-base-hand]");
    var variantInput = query(product, "[data-wbg-variant-input]");
    var salePrice = query(product, "[data-wbg-price]");
    var comparePrice = query(product, "[data-wbg-compare]");
    var savings = query(product, "[data-wbg-savings]");
    var addPrice = query(product, "[data-wbg-add-price]");
    var addButton = query(product, "[data-wbg-add]");
    var error = query(product, "[data-wbg-error]");
    var defaultPack =
      Number(product.getAttribute("data-wbg-default-pack")) || 1;
    var baseVariantId = variantInput
      ? variantInput.getAttribute("data-wbg-base-variant") || variantInput.value
      : "";
    var state = { pack: defaultPack, variantId: baseVariantId };

    function handednessValues() {
      if (state.pack === 1) return [baseHand ? baseHand.value : "Right-Handed"];
      return queryAll(handednessList, "select").map(function (select) {
        return select.value;
      });
    }

    function renderHandedness(pack, controls) {
      if (!handednessFieldset || !handednessList) return;
      // The base row carries its own single handedness select, so this fieldset
      // stays out of the way when that row is the active choice. A one-pack
      // picked from a pack card still needs a control here: hiding the fieldset
      // without emptying it left six stale selects in the form, which still
      // submit, so a left-handed buyer had no way to say so and every single
      // order went out marked right-handed.
      if (pack === 1 && !controls) {
        handednessList.textContent = "";
        handednessFieldset.hidden = true;
        return;
      }
      var previous = handednessValues();
      handednessList.textContent = "";
      for (var index = 0; index < pack; index += 1) {
        handednessList.appendChild(
          makeHandednessControl(index, previous[index] || "Right-Handed"),
        );
      }
      handednessFieldset.hidden = false;
      if (controls) controls.appendChild(handednessFieldset);
    }

    // Prices are rendered by Liquid's money filters and read back as strings, so
    // every market (USD, GBP, EUR, CAD, AUD) shows its own currency and the
    // displayed price always matches what checkout charges.
    function updatePriceFrom(el) {
      if (!el) return;
      var money = el.getAttribute("data-price-money");
      var compareMoney = el.getAttribute("data-compare-money");
      if (salePrice) salePrice.textContent = money || "";
      if (comparePrice) {
        comparePrice.textContent = compareMoney || "";
        comparePrice.hidden = !compareMoney;
      }
      if (savings) savings.textContent = el.getAttribute("data-savings") || "";
      if (addPrice)
        addPrice.textContent = el.getAttribute("data-add-money") || money || "";

      // Broadcast the selected tier so anything else on the page showing an
      // offer (closing CTA, sticky bar) follows the buy box instead of quoting
      // a price the shopper did not choose.
      var titleEl = el.querySelector(".wbg-pack__title");
      var name = "";
      if (titleEl) {
        var clone = titleEl.cloneNode(true);
        var pill = clone.querySelector("em");
        if (pill) pill.remove();
        name = clone.textContent.replace(/\s+/g, " ").trim();
      }
      document.dispatchEvent(
        new CustomEvent("wbg:tier-change", {
          detail: {
            name: name,
            quantity: Number(el.getAttribute("data-wbg-pack")) || 1,
            priceMoney: money || "",
            compareMoney: compareMoney || "",
            addMoney: el.getAttribute("data-add-money") || money || "",
            savings: el.getAttribute("data-savings") || "",
          },
        }),
      );
    }

    function selectBasePack() {
      state.pack = 1;
      state.variantId = baseVariantId;
      packButtons.forEach(function (item) {
        item.classList.remove("is-selected");
        item.setAttribute("aria-pressed", "false");
      });
      if (baseOption) baseOption.classList.add("is-selected");
      if (variantInput && state.variantId) variantInput.value = state.variantId;
      // Choosing the single option must show the single's price. Showing the
      // default multipack here made the header quote a price the cart never charged.
      updatePriceFrom(
        product.querySelector('[data-wbg-pack="1"]') || packButtons[0],
      );
      renderHandedness(1);
    }

    function selectPack(button) {
      var pack = Number(button.getAttribute("data-wbg-pack"));
      state.pack = pack;
      state.variantId = button.getAttribute("data-variant-id") || "";
      packButtons.forEach(function (item) {
        var selected = item === button;
        item.classList.toggle("is-selected", selected);
        item.setAttribute("aria-pressed", selected ? "true" : "false");
      });
      if (baseOption) baseOption.classList.remove("is-selected");
      if (variantInput && state.variantId) variantInput.value = state.variantId;
      updatePriceFrom(button);
      renderHandedness(pack, query(button, "[data-wbg-pack-controls]"));
    }

    packButtons.forEach(function (button) {
      button.setAttribute("aria-pressed", "false");
      button.addEventListener("click", function (event) {
        if (event.target.closest("select")) return;
        selectPack(button);
      });
      button.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        selectPack(button);
      });
    });
    if (baseHand) baseHand.addEventListener("change", selectBasePack);

    // Pages that sell a specific tier (the listicle, ads) link in with ?pack=3 so
    // the shopper lands on the tier they just chose instead of being reset to the
    // customizer default. Ignored unless it names a tier that actually exists.
    var requestedPack = null;
    try {
      var askedFor = new URLSearchParams(window.location.search).get("pack");
      if (askedFor && product.querySelector('[data-wbg-pack="' + askedFor + '"]')) {
        requestedPack = askedFor;
      }
    } catch (err) {
      /* no URLSearchParams: fall through to the customizer default */
    }

    // Open on the tier marked default in the customizer so the preselected card,
    // the hidden variant and the headline price all agree from the first paint.
    var openingPack =
      product.querySelector(
        '[data-wbg-pack="' + (requestedPack || defaultPack) + '"]',
      ) || packButtons[0];
    if (openingPack) {
      selectPack(openingPack);
    } else {
      selectBasePack();
    }

    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        if (error) {
          error.hidden = true;
          error.textContent = "";
        }

        var item;
        try {
          item = buildCartItem(
            state.variantId || (variantInput && variantInput.value),
            state.pack,
            handednessValues(),
          );
        } catch (cartError) {
          if (error) {
            error.hidden = false;
            error.textContent = cartError.message;
          }
          return;
        }

        if (product.hasAttribute("data-wbg-preview")) {
          document.dispatchEvent(
            new CustomEvent("wbg:preview-cart", {
              detail: { item: item, pack: state.pack },
            }),
          );
          return;
        }
        form.dispatchEvent(
          new CustomEvent("wbg:add-to-cart", {
            bubbles: true,
            detail: { item: item, button: addButton, error: error },
          }),
        );
      });
    }
  }

  function enhanceComparison(comparison) {
    var input = query(comparison, "[data-wbg-comparison-input]");
    if (!input) return;

    // A drag moves faster than the screen refreshes. Collapse updates into one
    // write per frame so dragging does not queue up style work.
    var pending = null;
    function paint() {
      pending = null;
      comparison.style.setProperty("--wbg-position", input.value + "%");
    }
    function schedule() {
      if (pending === null) pending = requestAnimationFrame(paint);
    }
    // Arrow keys on the range input still drive it, which is why the input stays.
    input.addEventListener("input", schedule, { passive: true });

    function setFromClientX(clientX) {
      var box = comparison.getBoundingClientRect();
      if (!box.width) return;
      var pct = ((clientX - box.left) / box.width) * 100;
      var next = String(Math.round(Math.max(0, Math.min(100, pct))));
      if (next !== input.value) {
        input.value = next;
        schedule();
      }
    }

    // Touch needs intent detection. A finger landing here is usually the start
    // of a page scroll, not a drag, and a bare range input jumps to the touch
    // point on contact -- so the image twitched every time someone scrolled
    // past. Wait until the gesture is clearly sideways before taking it over,
    // and leave vertical gestures to the page.
    var SLOP = 8;
    var dragging = false;
    var decided = false;
    var pointerId = null;
    var startX = 0;
    var startY = 0;

    function capture() {
      dragging = true;
      try {
        comparison.setPointerCapture(pointerId);
      } catch (err) {
        /* capture is a nicety; dragging still works without it */
      }
    }

    comparison.addEventListener("pointerdown", function (event) {
      if (event.button > 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      decided = event.pointerType !== "touch";
      dragging = false;
      // A mouse or pen is unambiguous, so it grabs the divider straight away.
      if (decided) {
        capture();
        setFromClientX(event.clientX);
      }
    });

    comparison.addEventListener("pointermove", function (event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      if (!decided) {
        var dx = Math.abs(event.clientX - startX);
        var dy = Math.abs(event.clientY - startY);
        if (dx < SLOP && dy < SLOP) return;
        decided = true;
        if (dy > dx) {
          pointerId = null; // scrolling, not comparing
          return;
        }
        capture();
      }
      if (dragging) setFromClientX(event.clientX);
    });

    function release(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      if (dragging) {
        try {
          comparison.releasePointerCapture(pointerId);
        } catch (err) {
          /* already released */
        }
      }
      dragging = false;
      decided = false;
      pointerId = null;
    }
    comparison.addEventListener("pointerup", release);
    comparison.addEventListener("pointercancel", release);
  }

  function enhanceReviews(button) {
    button.addEventListener("click", function () {
      var section = button.closest("[data-wbg-section]");
      queryAll(section, ".wbg-review-card.is-extra").forEach(function (card) {
        card.hidden = false;
      });
      button.hidden = true;
    });
  }

  function enhanceCountdown(countdown) {
    var end = Date.now() + (3 * 60 * 60 + 41 * 60 + 27) * 1000;
    function update() {
      var remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;
      query(countdown, "[data-wbg-hours]").textContent = String(hours).padStart(
        2,
        "0",
      );
      query(countdown, "[data-wbg-minutes]").textContent = String(
        minutes,
      ).padStart(2, "0");
      query(countdown, "[data-wbg-seconds]").textContent = String(
        seconds,
      ).padStart(2, "0");
    }
    update();
    window.setInterval(update, 1000);
  }

  function boot(scope) {
    queryAll(scope || document, "[data-wbg-product]").forEach(enhanceProduct);
    queryAll(scope || document, "[data-wbg-comparison]").forEach(
      enhanceComparison,
    );
    queryAll(scope || document, "[data-wbg-reviews-more]").forEach(
      enhanceReviews,
    );
    queryAll(scope || document, "[data-wbg-countdown]").forEach(
      enhanceCountdown,
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        boot(document);
      },
      { once: true },
    );
  } else {
    boot(document);
  }
  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})(typeof window === "undefined" ? globalThis : window);
